// extracted by mini-css-extract-plugin
export var container = "_b0-0";
export var icon = "_b0-1";
export var text = "_b0-2";